import { type AxiosInstance } from "axios";

export interface SavedAddress {
  id: string;
  label: string;
  recipientName: string;
  address: {
    street: string;
    unit?: string | null;
    city: string;
    state: string;
    zip: string;
  };
}

export interface UserProfile {
  firstName: string;
  lastName: string;
  email: string;
  addresses: SavedAddress[];
  hideCarrierPackageModal: boolean;
}

export const getUserProfile = async (
  axiosInstance: AxiosInstance,
): Promise<UserProfile> => {
  const { data } = await axiosInstance.get("/user");
  return data;
};

export type CreateAddressPayload = Omit<SavedAddress, "id">;

export const addAddress = async (
  axiosInstance: AxiosInstance,
  payload: CreateAddressPayload,
): Promise<SavedAddress> => {
  const { data } = await axiosInstance.post("/user/address", payload);
  return data;
};

export type UserPreferences = Pick<UserProfile, "hideCarrierPackageModal">;

export const updateUserPreferences = async (
  axiosInstance: AxiosInstance,
  payload: UserPreferences,
): Promise<void> => {
  await axiosInstance.patch("/user/preferences", payload);
};
